import { Field } from "./field";

class Line extends Field {
  displaySelectType = "LINE";
  displayType = 110;

  constructor(field: unknown) {
    super(field);
    this.invalid = false;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setValue(): void {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  initValue(): void {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  clearValue(): void {}
}

export { Line };
